import ContactForm from './ContactForm.vue'
import Newsletter from './Newsletter.vue'

export default {
  ContactForm,
  Newsletter
}



// WEBPACK FOOTER //
// ./resources/js/components/index.js